<div class="iframe-wrapper">
  <!-- The iframe points to the local HTML file you created -->
  <iframe
    src="https://sesje.zalamo.com/assets/easypack.html"
    class="easy-pack-iframe"
    frameborder="0"
    scrolling="no"
  ></iframe>
</div>
